import React from 'react';
import Modal from './Modal';
import { FaExclamationTriangle, FaTrash, FaBan, FaCheck } from 'react-icons/fa';
import '../styles/ConfirmModal.css';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  type = 'warning', // 'warning', 'danger', 'success', 'info'
  loading = false
}) => {
  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <FaTrash className="confirm-icon danger" />;
      case 'warning':
        return <FaExclamationTriangle className="confirm-icon warning" />;
      case 'success':
        return <FaCheck className="confirm-icon success" />;
      default:
        return <FaBan className="confirm-icon info" />;
    }
  };

  const getConfirmButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'btn-danger';
      case 'warning':
        return 'btn-warning';
      case 'success':
        return 'btn-success';
      default:
        return 'btn-primary';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small" showCloseButton={false}>
      <div className="confirm-modal">
        <div className="confirm-icon-container">
          {getIcon()}
        </div>
        
        <div className="confirm-content">
          <h3 className="confirm-title">{title}</h3>
          <p className="confirm-message">{message}</p>
        </div>
        
        <div className="confirm-actions">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            className={`btn ${getConfirmButtonClass()}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Chargement...' : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;